<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>Edit Data Stream</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">
                What's the Content of the Conversation?
              </div>
              <v-textarea
                rows="3"
                :rules="rules"
                v-model="content"
                dense
                outlined
                counter
                maxlength="200"
                placeholder="Pin Content"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout v-if="permLink">
            <v-flex>
              <v-btn
                target="_blank"
                :href="permLink"
                class="text-none subtitle-2"
                color="primary"
              >
                <span>
                  Go to post
                </span>
                <v-icon
                  class="ml-2"
                  v-if="fromArray.indexOf('ig-crawler') != -1"
                >
                  mdi-instagram
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Schedule At</div>
              <v-text-field
                readonly
                v-model="scheduledAtDateString"
                hide-details
                dense
                outlined
                placeholder="Scheduled Date"
                @click="openScheduleDateDialog"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">Pin Options</div>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Region</div>
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="regions"
                v-model="region"
                item-text="name"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout>

          <!-- <v-layout class="mt-3">
            <v-flex xs6 class="mr-1">
              <div class="subtitle-2 mb-1">Link Name</div>
              <v-text-field
                v-model="linkName"
                hide-details
                dense
                outlined
                placeholder="Link Name"
              ></v-text-field>
            </v-flex>

            <v-flex xs6 class="ml-1">
              <div class="subtitle-2 mb-1">Link URL</div>
              <v-text-field
                v-model="linkUrl"
                hide-details
                dense
                outlined
                placeholder="Ex: http://..."
              ></v-text-field>
            </v-flex>
          </v-layout> -->
          <!-- <v-layout class="mt-3" v-if="attachment">
            <v-flex>
              <div class="subtitle-2 mb-1">
                Attachment (Download and Re-Upload Required)
              </div>
              <v-hover v-slot="{ hover }">
                <v-card color="black" width="100">
                  <a
                    :href="attachment"
                    :title="attachment"
                    :download="attachment"
                    target="_blank"
                  >
                    <v-img
                      aspect-ratio="1"
                      :src="attachment"
                      :lazy-src="attachment"
                    >
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="d-flex justify-center transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                          style="height: 100%; opacity: 0.6"
                        >
                          <v-icon color="white"> mdi-file-download </v-icon>
                        </div>
                      </v-expand-transition>
                    </v-img>
                  </a>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout> -->

          <gallery-image-select-section
            ref="galleryImageSelectSectionRef"
            @imageSelected="galleryImageSelected"
          />
          <v-layout v-if="imageUrl && !selectedFromGallery" class="mt-3">
            <v-flex>
              <v-card>
                <v-img
                  gradient="to top left, rgba(0,0,0,0), rgba(0,0,0,.7)"
                  aspect-ratio="1"
                  :lazy-src="imageUrl"
                  :src="imageUrl"
                >
                  <v-layout>
                    <v-btn icon small @click="galleryImageSelected({})">
                      <v-icon color="white"> mdi-close </v-icon>
                    </v-btn>
                  </v-layout>
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-checkbox
              v-model="markReviewed"
              hide-details
              label="Mark content as reviewed and schedule."
            />
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          <span v-if="markReviewed"> Schedule </span>
          <span v-else> Save </span>
        </v-btn>
      </v-card-actions>
    </v-card>
    <time-and-date-select-dialog
      @onDateSelected="onScheduleDateSelected"
      ref="ScheduleTimeAndDateDialogRef"
    />
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState, mapGetters } from 'vuex';
import firebase from 'firebase';
import _ from 'lodash';
import { auth } from '@/plugins/firebase';
import moment from 'moment';
import TimeAndDateSelectDialog from './TimeAndDateSelectDialog.vue';
import GalleryImageSelectSection from '@/modules/Assets/components/GalleryImageSelectSection';

export default {
  props: {
    selectedRegion: {
      type: Object,
      default: function() {
        return {};
      },
    },
    collection: {
      type: String,
      default: function() {
        return {};
      },
    },
  },
  components: {
    TimeAndDateSelectDialog,
    // ImageUploadSection,
    GalleryImageSelectSection,
  },
  data() {
    return {
      rules: [(v) => v.length <= 150 || 'Max 150 characters'],
      markReviewed: false,
      dialog: false,
      loading: false,
      dialogAction: '',
      scheduleDateDialog: false,
      scheduledAtDateField: '',
      scheduledAt: '',
      region: null,
      createdBy: '',
      content: '',

      isMarker: false,
      location: {},
      firebaseUrl: '',
      imageThumbnail: '',
      imageUrl: '',
      state: '',
      permLink: '',
      fromArray: [],

      id: '',
      linkName: '',
      linkUrl: '',
      attachment: '',
      selectedFromGallery: false,
    };
  },
  computed: {
    ...mapState('$_home', ['regions']),
    scheduledAtDateString() {
      if (this.scheduledAtDateField) {
        return this.iMoment(this.scheduledAtDateField);
      } else {
        return this.scheduledAt;
      }
    },
    changeFieldsCopy() {
      return {
        scheduledAt: this.iMoment(this.scheduledAtDateField),
        state: this.markReviewed ? 'scheduled' : this.state,

        type: 'conversation',
        region: this.region,
        createdBy: {
          id: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
        },
        content: {
          text: this.content,
        },

        data: {
          content: this.content,
          createdBy: auth.currentUser.uid,
          image: this.imageUrl
            ? {
                firebaseUrl: this.firebaseUrl,
                thumbnail: this.imageThumbnail,
                url: this.imageUrl,
              }
            : null,
          link: this.linkUrl
            ? {
                url: this.linkUrl,
                name: this.linkName,
              }
            : null,
          isMarker: this.isMarker,
          location: this.region
            ? new firebase.firestore.GeoPoint(
                parseFloat(this.region.latitude),
                parseFloat(this.region.longitude),
              )
            : null,
          score: Number(0),

          totalComments: Number(0),
          type: 'conversation',
          views: Number(0),
        },
      };
    },
    changeFields() {
      return {
        id: this.id,
        scheduledAt: this.iMoment(this.scheduledAtDateField),
        state: this.markReviewed ? 'scheduled' : this.state,

        type: 'conversation',
        region: this.region,
        content: {
          text: this.content,
        },

        data: {
          content: this.content,
          createdBy: auth.currentUser.uid,

          image: this.imageUrl
            ? {
                firebaseUrl: this.firebaseUrl,
                thumbnail: this.imageThumbnail,
                url: this.imageUrl,
              }
            : null,
          link: this.linkUrl
            ? {
                url: this.linkUrl,
                name: this.linkName,
              }
            : null,
          isMarker: this.isMarker,
          location: this.region
            ? new firebase.firestore.GeoPoint(
                parseFloat(this.region.latitude),
                parseFloat(this.region.longitude),
              )
            : null,
          score: Number(0),

          totalComments: Number(0),
          type: 'conversation',
          views: Number(0),
          showInFeed: true,
        },
      };
    },
  },

  watch: {
    searchTerm: _.debounce(function(e) {
      e && this.searchEntities(e);
    }, 300),
  },
  mounted() {
    this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
  },
  methods: {
    ...mapActions({
      createNewChat: '$_content/createNewContent',
      getStream: '$_content/getStream',
      getDataStreamByRegion: '$_content/getContentByRegion',
      updateStreamItem: '$_content/updateStreamItem',
      getRegions: '$_home/getContent',
    }),

    downloadItem({ url, label }) {
      axios
        .get(url, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = label;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    galleryImageSelected(image) {
      this.selectedFromGallery = image ? true : false;
      this.imageUrl = image.url;
      this.firebaseUrl = image.firebaseUrl ? image.firebaseUrl : '';
      this.imageThumbnail = image.thumbnail;
    },
    iMoment(date) {
      if (date) {
        // console.log(date);
        return moment(date).toDate();
      }
      return new Date();
    },
    toggleDialog(details, action) {
      this.dialog = !this.dialog;
      if (this.dialog) {
        console.log('Edit Details: ', details);

        this.dialogAction = action;

        this.id = details.id;
        this.scheduledAtDateField = details.scheduledAt
          ? details.scheduledAt.seconds * 1000
          : '';
        // this.expireAtDateField = details.data.expiresAt.seconds * 1000;
        this.scheduledAt = details.scheduledAt
          ? this.iMoment(details.scheduledAt.seconds * 1000)
          : '';
        this.state = details.state ? details.state : '';
        this.region = details.region ? details.region : details.entity.region;
        this.content = details.data
          ? details.data.content
          : details.content.text
          ? details.content.text
          : '';
        //   this.isMarker = true;
        this.permLink = details.permLink ? details.permLink : '';
        this.fromArray = details.from ? details.from : '';
        this.linkUrl = details.data
          ? details.data.link
            ? details.data.link.url
            : ''
          : '';
        this.linkName = details.data
          ? details.data.link
            ? details.data.link.name
            : ''
          : '';
        this.location = details.data
          ? details.data.location
          : this.region
          ? new firebase.firestore.GeoPoint(
              parseFloat(this.region.latitude),
              parseFloat(this.region.longitude),
            )
          : null;

        this.imageThumbnail = details.data
          ? details.data.image
            ? details.data.image.thumbnail
            : ''
          : details.content.image
          ? details.content.image.url
          : '';
        this.firebaseUrl = details.data
          ? details.data.image
            ? details.data.image.firebaseUrl
              ? details.data.image.firebaseUrl
              : ''
            : ''
          : '';
        this.imageUrl = details.data
          ? details.data.image
            ? details.data.image.url
            : ''
          : details.content.image
          ? details.content.image.url
          : '';
        this.attachment = details.content.attachment
          ? details.content.attachment
          : '';
      }
    },

    openScheduleDateDialog() {
      this.$refs.ScheduleTimeAndDateDialogRef.toggleDialog(
        this.scheduledAtDateField,
      );
    },
    onScheduleDateSelected(dateTime) {
      // console.log("Scheduled Selected Date and Time: ", dateTime);
      this.scheduledAtDateField = dateTime;
    },
    cancel() {
      this.scheduledAtDateField = '';
      this.expiresAtDateField = '';
      this.scheduledAt = '';
      this.region = '';
      this.state = '';
      this.region = {};

      this.createdBy = '';
      this.content = '';

      this.isMarker = false;
      this.location = {};
      this.imageThumbnail = '';
      this.imageUrl = '';
      this.id = '';
      this.linkUrl = '';
      this.linkName = '';

      if (this.selectedFromGallery == true) {
        this.$refs.galleryImageSelectSectionRef.galleryImageDeselect();
      }

      this.selectedFromGallery = false;

      this.dialog = false;
    },
    save() {
      console.log('edited Pin: ', this.changeFields);
      if (this.markReviewed) {
        if (!this.scheduledAtDateString) {
          alert('Yo yo, Slow down dude, add a Scheduled At time');
          return;
        }
        console.log('edited Pin: ', this.changeFields);
        this.createNewChat({
          details: this.changeFieldsCopy,
          collection: this.collection,
          type: 'Conversation',
        }).then(() => {
          this.updateStreamItem({
            details: this.changeFields,
            collection: 'crawlerstream',
          }).then(() => {
            this.cancel();
            this.getStream({ collection: 'crawlerstream' });
          });
        });
      } else {
        this.updateStreamItem({
          details: this.changeFields,
          collection: 'crawlerstream',
        }).then(() => {
          this.cancel();
          this.getStream({ collection: 'crawlerstream' });
        });
      }
    },
  },
};
</script>

<style></style>
